import React from 'react';

import { CaseStudyWithImageData } from 'stile-shared/src/utils/case-studies';
import styled from 'styled-components';

import CaseStudyTile from 'stile-shared/src/components/2024/common/CaseStudies/CaseStudyTile';
import { Section } from 'stile-shared/src/components/2024/layout/Section';

const CaseStudiesContainer = styled.div`
  width: 100%;
  gap: 0;
  @media (max-width: 1220px) {
    grid-layout {
      margin-top: 0 !important;
    }
  }
`;

const CaseStudiesGrid = styled(Section)`
  flex-shrink: 0;
  gap: 300px 28px;
  margin: 0 auto !important;
  padding: 0% !important;

  .content {
    padding-top: 0 !important;
    margin: 0 !important;
    width: auto !important;
  }

  @media (max-width: 1000px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    gap: 16px;
  }
  > * {
    flex-shrink: 0;
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;
type CaseStudiesCategoriesProps = {
  caseStudies: CaseStudyWithImageData[];
  featureIndex: number;
};

const CaseStudiesComponent: React.FC<CaseStudiesCategoriesProps> = ({
  caseStudies,
  featureIndex,
}) => {
  const filteredCaseStudies = caseStudies.filter((_, index) => index !== featureIndex);

  return (
    <CaseStudiesContainer>
      <CaseStudiesGrid>
        {filteredCaseStudies.map((study) => {
          return (
            <CaseStudyTile
              key={study.title}
              imgSrc={study.imageData}
              title={study.title}
              school={study.school + ', ' + study.state}
              description={study.description}
              url={`/why-choose-stile/case-studies/${study.slug}`}
              slug={study.slug}
            />
          );
        })}
      </CaseStudiesGrid>
    </CaseStudiesContainer>
  );
};

export default CaseStudiesComponent;
